import { JetView } from 'webix-jet';

/**
 * Class representing the details landing report view.
 * @extends JetView
 */
export default class detailsLandingReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Main information layout
        const main_info = {
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                {
                                    view: 'text', // Text input for ID
                                    name: 'Id',
                                    label: _("<span class='icon-id'></span> ID"),
                                    labelPosition: 'top',
                                    placeholder: _('Id'),
                                    invalidMessage: _('A ID is required'),
                                    disabled: true, // Disabled input
                                },
                                {
                                    view: 'text', // Text input for Type
                                    name: 'Type',
                                    label: _('Tipo'),
                                    labelPosition: 'top',
                                    placeholder: _('Tipo'),
                                    disabled: true, // Disabled input
                                },
                                {
                                    view: 'text', // Text input for Date
                                    name: 'Date',
                                    label: _('Fecha'),
                                    labelPosition: 'top',
                                    placeholder: _('Fecha'),
                                    disabled: true, // Disabled input
                                },
                                {
                                    view: 'text', // Text input for Amount
                                    name: 'Amount',
                                    label: _('Monto'),
                                    labelPosition: 'top',
                                    placeholder: _('Monto'),
                                    disabled: true, // Disabled input
                                    id: 'Monto', // ID for later reference
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Left main layout configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Upper section layout with multiview and scroll
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main],
        };

        // Narrow upper section layout
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Window configuration for detailsCasino
        const detailsCasino = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsCasino',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2',
                type: 'clean',
                padding: 10,
                rows: [upper_section_narrow],
            },
        });

        // Main form configuration
        return {
            view: 'form',
            id: 'formDetails',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? upper_section // Use upper_section for larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(this.app, 'bonusTransDetail:select', (person) => {
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Monto').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for smaller screens
            }
        });
    }
}

// FILE DOCUMENTED
